(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('HighChartsCtrl', HighChartsCtrl);

  // @ngInject
  function HighChartsCtrl() {
    var vm = this;

    var chart, dataOptions, container;

    vm.onLoad = function (containerElem) {
      container = containerElem;
      loadChart(vm.options, true);

      vm.getData()
          .then(function (data) {
            dataOptions = vm.chartDataOptions({ rawData: data });
            var chartOptions = _.merge({}, vm.options, dataOptions);
            vm.options = chartOptions;
            vm.setParentValues && vm.setParentValues({ formattedData: data });
            loadChart(chartOptions, false);
          })
          .catch(function () {
            loadChart(vm.options, false, "Could not load chart data")
          });
    };

    function loadChart(options, loading, errorText) {
      chart && chart.destroy();
      chart = Highcharts.chart(container, options);

      if(loading) {
        chart.showLoading("<span class=\"fa fa-3x fa-refresh fa-spin fa-fast-anim\"></span>\n" +
            "              <div class=\"p-t-10\">Loading Charts...</div>");
      } else {
        if(errorText) {
          chart.showLoading("<div class=\"p-t-10\">"+ errorText +"</div>");
        } else {
          // condition for no data
          if(chart.series && _.some(chart.series, function (chartSeries) {
            return chartSeries.hasData();
          })) {
            chart.hideLoading();
          } else {
            chart.showLoading("<div class=\"p-t-10\">No Data</div>");
          }
        }
      }
    }

  }

  })();
